import type { NextPage } from "next";

import { siteDataQuery } from "lib/sanity/queries";
import { getClient } from "lib/sanity/server";

import Memberships from "components/views/about/membership";
import { SiteData } from "components/views/constants";

import Page from "../../components/layout/page";
import Careers from "../../components/views/about/careers";
import History from "../../components/views/about/history";
import MainHero from "../../components/views/about/main-hero";
import WhyEnerflo from "../../components/views/about/why-enerflo";

type AboutUsProps = { siteData: SiteData };
const AboutUs: NextPage<AboutUsProps> = ({ siteData }: AboutUsProps) => (
  <Page
    title="Enerflo Solar Software Platform | About Us"
    description="At Enerflo, we’re on a mission to spread solar energy across the globe, one well-executed deal at a time, and we can’t do it alone. Join us for the ride?"
  >
    <MainHero />
    <History data={siteData} />
    <WhyEnerflo />
    <Memberships />
    <Careers />
  </Page>
);

export default AboutUs;

export async function getStaticProps(ctx) {
  const client = getClient(ctx.preview);
  let siteData = null;

  try {
    const data = await client.fetch(siteDataQuery);

    if (data) {
      siteData = data;
    }
  } catch (e) {
    console.error("Unable to fetch site data", e);
  }

  return {
    props: {
      siteData,
    },
  };
}
